import React from 'react';
import { Fab, SxProps, Theme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import AddIcon from '@mui/icons-material/Add';
import appTema from '../../servicos/mui/Theme';
import { isNull } from 'lodash';

interface IBotaoProps {
	handleClick: () => Promise<void>;
	url?: string
	ehNovaJanela?: boolean
	sxProps?: SxProps<Theme>
 }

const BotaoAdicionar: React.FC<IBotaoProps> = (BotaoProps) => {
	const isSmallScreen = useMediaQuery(appTema.breakpoints.down('md'));
	const fabSize = isSmallScreen ? 'small' : 'medium';

	const handleClick = () => {
		if (BotaoProps.url) {
			if (!isNull(BotaoProps.ehNovaJanela) && BotaoProps.ehNovaJanela) {
				window.open(BotaoProps.url, "_blank");
			} else {
				window.location.href = BotaoProps.url!;
			}
		} else {
			BotaoProps.handleClick(); // Aqui, estamos invocando a função. Não há necessidade de props aqui.
		}
	 };

	return (
			<Fab 
				title="Novo item"
				aria-label="Adicionar"
				variant="circular" 
				color="primary" 
				size={fabSize} 
				onClick={handleClick}
				sx={BotaoProps.sxProps} 
			>
				<AddIcon/>
			</Fab>
		);
};
export default BotaoAdicionar;
